var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m30.344 3.57-2.856 11.455M53.25 9.282l-2.856 11.454M60.414 17.125 20.328 7.13a5.9 5.9 0 0 0-7.154 4.3L3.178 51.52a5.9 5.9 0 0 0 4.299 7.155l40.086 9.995a5.9 5.9 0 0 0 7.154-4.3l9.996-40.09a5.9 5.9 0 0 0-4.299-7.155M10.322 22.866l51.54 12.85m-40.08 2.174.03.007m11.424 2.848.029.007m11.424 2.849.029.007m-25.791 5.736.029.007M30.38 52.2l.029.007m11.424 2.848.029.008"
  })));
};
export default SvgCalendar;